import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Events } from 'ionic-angular';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

import { AuthServiceProvider } from '../auth-service/auth-service';

/*
  Generated class for the DocumentoServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class DocumentoServiceProvider {

  serverServicios = "";
  headers = new Headers();
  headersPost:any;
  constructor(public http: Http, public autorizacionService: AuthServiceProvider, public events: Events) {
    
    //this.serverServicios = "http://localhost:3000";
    this.serverServicios = "http://165.227.106.28:3000";
    this.headers.append('Authorization', this.autorizacionService.token);

    this.headersPost = new Headers({ 'Content-Type': 'application/json' });
    this.headersPost.append('Authorization', this.autorizacionService.token);
  }

  getResults(keyword:string) {
    return this.http.get(this.serverServicios + '/posdocumento/1/-1/1', {headers: this.headers})
      .map(
        result =>
        {
          return result.json()
        });
  }

  guardar(data)
  {
  	return new Promise((resolve, reject) => {
  		this.http.post( this.serverServicios + '/posdocumento/', JSON.stringify(data),  { headers: this.headersPost }).subscribe(res => {
			resolve(res);
		}, (err) => {
      this.events.publish('user:validartoken', err._body);
			reject(err);
		});
    });
  }

  buscar(iddocumento,idtipo)
  {
  	return new Promise(resolve => {
  		this.http.get(this.serverServicios + '/posdocumento/1/' + iddocumento + '/' + idtipo, {headers: this.headers}).map(res => res.json()).subscribe(data => {
			resolve(data);
		}, err => {
      this.events.publish('user:validartoken', err._body);
			console.log(err);
		});
	});
  }

}



// WEBPACK FOOTER //
// ./src/providers/documento-service/documento-service.ts